/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */

import { debounce } from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPayOffReportAmount, getReportData, getTotalCount } from '../../../../../api/reports';
import { useSetLoading } from '../../../../../common/hooks/appearance';
import { usePagination } from '../../../../../common/hooks/data';
import { fetchDashboardFilterData } from '../../../../../utils/constant';
import { apiErrorHandler } from '../../../../../utils/handlers';
import PayOffReportTable from './PayOffTable';
import PayOffFilter from './payOffFilter';
import PayoffCalculateFilter from './payoffCalculateFilter';

const PayOffReport = ({ setShowTable, tableName, showTable }) => {
  const [payOffTableData, setPayOffTableData] = useState({
    tableData: [],
    count: null,
    showTable: false,
  });
  const filterData = useSelector((state) => state.filters.dashboardMultiSelectFilters);
  const { page, limit, setPage, setLimit } = usePagination();
  const [showCalculateFilter, setShowCalculateFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({});
  const [applyFilters, setApplyFilters] = useState(false);
  const [amountTableData, setAmountTableData] = useState({
    data: {},
    showTable: false,
  });
  const [searchText, setSearchText] = useState('');
  const [contractNumberValue, setContractNumberValue] = useState(null);
  const onCheckClick = async (contractNumber) => {
    try {
      setContractNumberValue(contractNumber);
      setLoading(true);
      const { data } = await getPayOffReportAmount(tableName, {
        contractNumber,
      });
      setAmountTableData({ data: data?.data[0], showTable: false });
      setLoading(false);
      setShowCalculateFilter(true);
    } catch (error) {
      setLoading(false);
      apiErrorHandler(error);
    }
  };
  const calculateHandler = async (params) => {
    try {
      setLoading(true);
      const { data } = await getPayOffReportAmount(tableName, {
        ...params,
        contractNumber: contractNumberValue,
      });
      setAmountTableData({ data: data?.data[0], showTable: true });
      setLoading(false);
    } catch (err) {
      setAmountTableData({ data: [], showTable: false });
      setLoading(false);
      apiErrorHandler(err);
    }
  };
  const onSearchClick = async (params, type) => {
    let payloadValue = { ...params };
    if (type === 'filterSearch') {
      setPayload({ ...params });
      setPage(payloadValue?.page);
      setLimit(payloadValue?.limit);
    } else if (type === 'search') {
      setPage(1);
      setLimit(5);
      payloadValue.page = 1;
      payloadValue.limit = 5;
      setPayload({ ...payload, ...payloadValue });
      payloadValue = { ...payload, ...payloadValue };
    } else {
      setPayload({ ...payload, ...payloadValue });
      payloadValue = { ...payload, ...payloadValue };
    }
    try {
      setApplyFilters(false);
      setLoading(true);
      payloadValue = {
        ...payloadValue,
        ...fetchDashboardFilterData(filterData),
      };
      const { data } = await getReportData(tableName, payloadValue);
      const response = await getTotalCount(tableName, {
        ...payloadValue,
      });

      setPayOffTableData({
        ...payOffTableData,
        count: response?.data?.data?.totalCount,
        tableData: data?.data?.items,
        showTable: true,
      });
      setAmountTableData({ data: [], showTable: false });
      setShowCalculateFilter(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      apiErrorHandler(error);
    }
  };
  const debounceApiCall = useCallback(
    debounce((val) => {
      onSearchClick({ ...payload, opiOrName: val }, 'search');
    }, 2000),
    [],
  );
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  return (
    <div className="pay-off-div">
      <PayOffFilter
        setShowTable={setShowTable}
        showTable={showTable}
        onSearchClick={onSearchClick}
        isTableGenerated={payOffTableData?.showTable}
        searchText={searchText}
      />
      {!showCalculateFilter && payOffTableData?.showTable && (
        <PayOffReportTable
          loading={loading}
          setLoading={setLoading}
          payload={payload}
          payOffTableData={payOffTableData}
          onCheckClick={onCheckClick}
          setApplyFilters={setApplyFilters}
          applyFilters={applyFilters}
          onSearchClick={onSearchClick}
          debounceApiCall={debounceApiCall}
          searchText={searchText}
          setSearchText={setSearchText}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
        />
      )}
      {showCalculateFilter && (
        <PayoffCalculateFilter
          setShowCalculateFilter={setShowCalculateFilter}
          calculateHandler={calculateHandler}
          amountTableData={amountTableData}
          setAmountTableData={setAmountTableData}
        />
      )}
    </div>
  );
};

export default PayOffReport;
